import axios from "axios";
import Swal from "sweetalert2";
import { exportaExcelConFotoOpcional } from "./excelConFotos";

// Baja a Excel el detalle por talla y color de cualquier paso del flujo.
// El back ya lo devuelve aplanado (un renglon por variante), asi que aqui solo
// se pide, se limpian las columnas internas y se manda al exportador, que es el
// mismo que pregunta si se quiere la foto del modelo.
//
//   descargaPorTallaColor("pedidos", "PedidosPorTallaColor")
const PASOS = {
  pedidos: "Pedidos",
  ordenesCompra: "OrdenesCompra",
  embarques: "Embarques",
  entradas: "Entradas",
  surtidos: "Surtidos",
};

export async function descargaPorTallaColor(paso, nombreArchivo, filtro) {
  const url = `${process.env.REACT_APP_URL_DETALLE_VARIANTES}/${paso}`;
  try {
    Swal.fire({ title: "Armando el Excel", html: "Un momento...", allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
    const r = await axios.get(url, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
    Swal.close();
    let filas = r.data || [];
    if (typeof filtro === "function") filas = filas.filter(filtro);
    if (!filas.length) {
      Swal.fire({ icon: "info", title: "Sin renglones", text: "No hay nada que exportar." });
      return;
    }
    // las columnas salen del propio renglon; las que empiezan con _ son internas
    const columnas = Object.keys(filas[0]).filter((k) => k !== "_id" && !k.startsWith("_id"));
    exportaExcelConFotoOpcional({
      filas,
      columnas,
      nombreArchivo: nombreArchivo || `${PASOS[paso] || paso}PorTallaColor`,
      hoja: "PorTallaColor",
    });
  } catch (error) {
    Swal.close();
    Swal.fire({ icon: "error", title: "No se pudo bajar el detalle", text: error.response?.data?.message || error.message });
  }
}

export default descargaPorTallaColor;
